import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Box } from '@primer/react';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ImageBox = makeShortcode("ImageBox");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ImageBox caption="Primer is a part of the Figma community and can be found using its Figma handle of @primer" mdxType="ImageBox">
  <img width="656" alt="Screenshot of the Primer profile within the Figma community" src="https://user-images.githubusercontent.com/10384315/93832644-3028e080-fc2b-11ea-88d1-a7515c04fe39.png" />
    </ImageBox>
    <p>{`Design teams at GitHub use Figma as the single source of truth, collaboration, and exploration. Access to the GitHub Figma organization is currently only available to members of the GitHub team. Public access to any shared libraries and files is available from the `}<a parentName="p" {...{
        "href": "https://www.figma.com/@primer"
      }}>{`Primer Figma Community page`}</a>{`.`}</p>
    <h2>{`Team libraries`}</h2>
    <p>{`GitHub's uses Figma to distribute Primer through team libraries. Each library covers a different part of the system, allowing a designer to only use what's needed. Any team within GitHub's Figma organization can create and distribute their own team/project specific libraries, but all of the core asset libraries for Primer can be found in the Primer team's "`}<a parentName="p" {...{
        "href": "https://www.figma.com/files/797266083973274396/project/8172024/Core-libraries"
      }}>{`Core libraries (internal)`}</a>{`" project or the `}<a parentName="p" {...{
        "href": "https://www.figma.com/@primer"
      }}>{`primer community page`}</a>{`. They include the following:`}</p>
    <ul>
      <li parentName="ul">{`Primer Primitives (`}<a parentName="li" {...{
          "href": "https://www.figma.com/file/B5XPE8IwGPIZDAvN7jqWqx/Primer-Primitives"
        }}>{`internal`}</a>{` | `}<a parentName="li" {...{
          "href": "https://www.figma.com/community/file/854766928300977832"
        }}>{`community`}</a>{`): All of the color, type, and spacing styles used within Primer.`}</li>
      <li parentName="ul">{`Primer Web (`}<a parentName="li" {...{
          "href": "https://www.figma.com/file/GCvY3Qv8czRgZgvl1dG6lp/Primer-Web?node-id=1406%3A0&t=kY6ZvRffnaGOaUib-1"
        }}>{`internal`}</a>{` | `}<a parentName="li" {...{
          "href": "https://www.figma.com/community/file/854767373644076713"
        }}>{`community`}</a>{`): UI components used to design for GitHub's web interfaces.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/file/csCViryWkkXwBsK1aLrO0X/Primer-Mobile"
        }}>{`Primer Mobile (internal only)`}</a>{`: UI components used to design for GitHub's native mobile platforms.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/community/file/809920999413919915"
        }}>{`Octicons`}</a>{`: GitHub's custom icon library.`}</li>
    </ul>
    <h2>{`Interface templates`}</h2>
    <ImageBox caption="Example templates from Primer Interfaces and Primer Email" mdxType="ImageBox">
  <img width="656" alt="screenshot of repo home page and email template" src="https://user-images.githubusercontent.com/10384315/93832849-d1b03200-fc2b-11ea-98ff-685f22236f6f.png" />
    </ImageBox>
    <p>{`In addition to asset libraries for components and styles, you can also use template libraries to jump-start the design process.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/file/Y2xJLFBrU7yyiDLlEkQXcF/Primer-Interfaces"
        }}>{`Primer Interfaces`}</a>{`: Templates for common views and UI patterns found within GitHub's web product.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/file/MZM32u6Q80DOvOGlDCNIyc/Primer-Email"
        }}>{`Primer Email`}</a>{`: Templates used to design product emails for GitHub.`}</li>
    </ul>
    <h2>{`Support`}</h2>
    <p>{`GitHub's Figma organization is currently maintained by GitHub's Design Infrastructure team. For any questions or comments please reach out to us either in our Slack `}<a parentName="p" {...{
        "href": "https://github.slack.com/archives/C049REXSRBQ"
      }}>{`#primer-figma`}</a>{` channel or by submitting an issue in the `}<a parentName="p" {...{
        "href": "https://github.com/github/primer/issues/new/choose"
      }}>{`github/primer repo`}</a>{`.`}</p>
    <p>{`For additional support specific to Figma, please reference the `}<a parentName="p" {...{
        "href": "https://help.figma.com/hc/en-us"
      }}>{`Figma Help Center`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      